(function () {
  if (window.__colorSwatchesInit) return;
  window.__colorSwatchesInit = true;

  const productCache = window.__shopifyProductCache || (window.__shopifyProductCache = new Map());

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}products/${handle}.js`);
      if (!response.ok) {
        productCache.set(handle, null);
        return null;
      }

      const product = await response.json();
      productCache.set(handle, product);
      return product;
    } catch {
      productCache.set(handle, null);
      return null;
    }
  }

  function hideEmptySwatchContainer(container) {
    const list = container.querySelector('.product-color-swatches__list');
    if (!list || list.querySelector('.product-color-swatch')) return;

    const wrapper = container.closest('[data-product-card-swatches]');
    if (wrapper) {
      wrapper.remove();
    } else {
      container.remove();
    }
  }

  async function filterPendingCardSwatches(container) {
    if (container.dataset.cardSwatchesFiltered === 'true') return;

    const pendingSwatches = container.querySelectorAll('.product-color-swatch--availability-pending');
    if (pendingSwatches.length === 0) {
      container.dataset.cardSwatchesFiltered = 'true';
      return;
    }

    await Promise.all(
      Array.from(pendingSwatches).map(async (swatch) => {
        const handle = swatch.dataset.productHandle;
        const productData = await fetchProduct(handle);

        if (!productData?.available) {
          swatch.remove();
          return;
        }

        swatch.classList.remove('product-color-swatch--availability-pending');

        if (swatch.dataset.productUrl == null && productData.url) {
          swatch.dataset.productUrl = productData.url;
        }
      })
    );

    container.dataset.cardSwatchesFiltered = 'true';
    hideEmptySwatchContainer(container);
  }

  function initCardSwatchFilter(root = document) {
    root.querySelectorAll('[data-filter-card-swatches]:not([data-card-swatches-filtered])').forEach((container) => {
      const run = () => filterPendingCardSwatches(container);
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(run, 0);
      }
    });
  }

  initCardSwatchFilter();

  document.addEventListener('shopify:section:load', (event) => {
    initCardSwatchFilter(event.target);
  });
})();
